import { render, staticRenderFns } from "./KatalogBukuAdd.vue?vue&type=template&id=c4854b10&scoped=true"
import script from "./KatalogBukuAdd.vue?vue&type=script&lang=js"
export * from "./KatalogBukuAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4854b10",
  null
  
)

export default component.exports